<p-toast class="responsive-toast" position="bottom-right" [preventDuplicates]="false" [preventOpenDuplicates]="true"></p-toast>
<router-outlet></router-outlet>
